import styles from './Logo.module.css';

export function Logo({ className }: { className?: string }) {
    return <img className={`${styles.logo} ${className}`} alt="" />;
}
